(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1873],{

/***/ 513:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/iot-and-digital-eng",
      function () {
        return __webpack_require__(6721);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MethodologyAnchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var steps = [
    {
        step: "01",
        title: "Discovery sprint",
        desc: "2 weeks, fixed price. We scope the problem, audit your data, and produce a written roadmap, cost estimate, and risk register. You decide whether to proceed — no commitment beyond the sprint."
    },
    {
        step: "02",
        title: "Build",
        desc: "Fixed-scope first phase or time-and-materials with a cap. Production-grade code, not a prototype. Delivered into your cloud environment with tests, monitoring, and handoff documentation."
    },
    {
        step: "03",
        title: "Operate",
        desc: "4–8 week warranty period post-handoff. Bugs and regressions fixed at zero cost. Ongoing ops available — we don't disappear after delivery."
    }, 
];
function MethodologyAnchor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-5xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-2",
                    children: "How an engagement works"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-gray-500 mb-10 text-base",
                    children: "No open-ended retainers. Every engagement starts with a bounded, fixed-price discovery."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-8",
                    children: steps.map(function(s) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-bold text-[#f1aa4e]",
                                    children: s.step
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-600 text-sm leading-relaxed",
                                    children: s.desc
                                })
                            ]
                        }, s.step);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/itmtb-how-we-work",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "text-blue-600 font-semibold text-sm hover:underline",
                            children: "Full methodology and engagement shapes →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 6721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2100);
/* harmony import */ var _components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(710);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4837);






var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});







var ContactUsHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6245).then(__webpack_require__.bind(__webpack_require__, 6245));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6245)
            ];
        }
    },
    ssr: false
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
iotAndDigitalEng.title = "IoT & Edge AI Engineering for Industrial Operations | ITMTB";
iotAndDigitalEng.desc = "ITMTB builds IoT and edge AI systems for industrial operations — connected factory intelligence, predictive maintenance, real-time sensor data platforms, and Industry 4.0 deployments.";
iotAndDigitalEng.header_img = "https://www.itmtb.com/services/capability/iot.webp";
iotAndDigitalEng.keywords = "IoT consulting India manufacturing, edge AI India industrial, Industry 4.0 implementation India, IoT sensor data platform India, predictive maintenance AI India, connected factory India, AWS IoT Core Azure IoT Hub India";
var faqItems = [
    {
        q: "What is edge AI for manufacturing and how does it differ from cloud AI?",
        a: "Cloud AI sends data to a remote server for inference and receives results back — this introduces latency (typically 50–500ms round-trip) and requires reliable network connectivity. Edge AI runs inference on a device physically close to or on the machine generating the data — latency drops to 1–10ms, and the system works even when network connectivity is degraded. For manufacturing, the distinction matters for: quality control (vision-based defect detection needs sub-10ms to keep up with production line speeds); safety monitoring (operator proximity detection can't wait for a cloud round-trip); predictive maintenance (running anomaly detection on sensor streams locally rather than batch-uploading to cloud). The hardware for edge inference ranges from NVIDIA Jetson modules for vision workloads to microcontrollers running TensorFlow Lite for simpler anomaly detection on sensor data. We select the right inference hardware for the latency and power constraints of your specific use case."
    },
    {
        q: "What is a digital twin and when does it make sense to build one?",
        a: "A digital twin is a software model of a physical asset (a machine, a production line, a facility) that is updated in real time from sensor data, enabling you to simulate, predict, and optimise the physical system without interrupting it. The business cases where a digital twin has clear ROI: predictive maintenance (the twin predicts failure before it occurs by modelling wear patterns across the sensor data history); capacity optimisation (simulating production schedule changes against the twin before committing to them physically); remote monitoring (inspecting the state of equipment across multiple sites without physical presence); and quality control (correlating production conditions at the moment of a defect with the twin's state to identify the root cause faster). Digital twins are not universally worth building — they require good sensor coverage, reliable data pipelines, and ongoing calibration. We assess fit during the discovery sprint rather than recommending them as a default."
    },
    {
        q: "How do IoT systems connect to ERP and production management software?",
        a: "The integration between IoT sensor data and ERP (SAP, Dynamics 365, Odoo) or MES (Manufacturing Execution Systems) is the layer where most industrial IoT projects stall. IoT generates high-frequency time-series data (thousands of events per second per machine); ERPs and MES expect structured, lower-frequency transactional records. Bridging them requires: an IoT data platform (AWS IoT Core, Azure IoT Hub, or an on-premises MQTT broker) to receive and buffer raw sensor streams; a transformation layer that aggregates sensor events into business-meaningful records (e.g., shift production summaries, quality hold events, maintenance alerts); and an integration service that writes the transformed records into the ERP or MES in the format those systems expect. OPC-UA is the standard protocol for connecting to industrial control systems (PLCs, SCADA) that most manufacturing ERPs also support. We architect and build this integration stack as a defined deliverable — not an afterthought added after the IoT devices are already deployed."
    },
    {
        q: "What protocols does ITMTB use for industrial IoT deployments?",
        a: "Protocol selection depends on the industrial environment and device constraints. MQTT is the standard for internet-connected IoT devices: lightweight, reliable over unreliable networks, widely supported by cloud IoT platforms (AWS IoT Core, Azure IoT Hub, Google Cloud IoT). OPC-UA is the standard for industrial automation: used by PLCs, SCADA systems, and modern CNC machines — it provides standardised read/write access to machine data. For legacy equipment that only exposes Modbus or other older protocols, we deploy protocol translation gateways (often running on edge devices) that convert legacy protocols to MQTT or OPC-UA for the rest of the architecture. For time-series data storage: Apache Kafka or AWS Kinesis for high-throughput streaming; InfluxDB or TimescaleDB for time-series querying; object storage (S3, Azure Blob) for raw sensor archive. We select the protocol and storage stack based on your device ecosystem and data volume, not based on a preferred technology."
    },
    {
        q: "How does ITMTB price an engagement?",
        a: "Pricing follows the engagement model. Discovery sprints are fixed-price for a fixed timebox. Build engagements are scoped after discovery — fixed-scope, time-and-materials, or outcome-linked. Managed services are billed monthly with defined SLAs. Total cost depends on scope, integration complexity, QA depth, and post-launch support — we publish a transparent breakdown for buyers evaluating their options.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
iotAndDigitalEng.faq = faqItems;
function iotAndDigitalEng() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    var filteredInsights = insights.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("IoT and Digital Engineering");
    });
    var filteredCaseStudies = caseStudies.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("IoT and Digital Engineering");
    });
    if (filteredInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(filteredInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights.filter(function(item) {
            return !filteredInsights.includes(item);
        }), 1)));
    } else if (filteredInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(filteredInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights, 2);
    }
    if (filteredCaseStudies.length === 1) {
        caseStudies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(filteredCaseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies.filter(function(item) {
            return !filteredCaseStudies.includes(item);
        }), 1)));
    } else if (filteredCaseStudies.length >= 2) {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(filteredCaseStudies, 2);
    } else {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies, 2);
    }
    var subServices = [
        {
            img: null,
            key: "Connected Factory Intelligence",
            title: "Plant floor data — from PLCs, sensors, and SCADA — made accessible, structured, and actionable.",
            text: "We connect industrial equipment to a modern data platform using OPC-UA for automation systems and MQTT for internet-connected devices. Raw sensor streams are aggregated and structured into shift-level and event-level records that operations teams can actually use — and that ERP and MES systems can ingest.\n\nFor legacy equipment that only exposes Modbus or proprietary protocols, we deploy edge gateway devices that translate to standard protocols, preserving your existing capital equipment investment while making its data accessible."
        },
        {
            img: null,
            key: "Edge AI and Real-Time Decision Making",
            title: "Intelligence where it's produced — inference at the edge, not the cloud.",
            text: "For use cases where cloud round-trip latency is too slow — quality control on production lines, safety monitoring, real-time anomaly detection — we deploy AI inference at the edge using NVIDIA Jetson modules for vision workloads and TensorFlow Lite for sensor-based anomaly detection on constrained hardware.\n\nEdge AI systems work when network connectivity is degraded, which matters for industrial environments where reliable connectivity to cloud cannot be guaranteed during operations."
        },
        {
            img: null,
            key: "Predictive Maintenance and Digital Twin",
            title: "Predict equipment failure before it happens. Simulate production changes before you commit to them.",
            text: "Predictive maintenance models train on historical sensor data (vibration, temperature, pressure, current draw) to identify the early signatures of component failure — typically catching failures days to weeks before they would cause unplanned downtime. We build these models, connect them to your sensor streams, and wire alerts into your maintenance workflow.\n\nDigital twins extend this: a real-time software model of a physical asset that enables capacity simulation, remote monitoring across sites, and faster root-cause analysis when defects occur."
        },
        {
            img: null,
            key: "IoT Data Platform and Pipeline Engineering",
            title: "High-frequency sensor streams ingested, structured, and made queryable — at scale.",
            text: "IoT deployments at industrial scale generate millions of events per hour. The data platform architecture has to handle the ingest volume, store efficiently for time-series querying, and route events to downstream systems in real time.\n\nWe architect and build IoT data platforms on AWS IoT Core, Azure IoT Hub, or on-premises MQTT brokers — with time-series storage (InfluxDB, TimescaleDB), streaming pipelines (Kafka, Kinesis), and integration adapters for ERP and MES systems."
        },
        {
            img: null,
            key: "Smart Product and Connected Device Development",
            title: "Building intelligence into physical products — from firmware to cloud backend to mobile interface.",
            text: "For product companies adding connectivity to hardware — consumer devices, industrial equipment, medical devices — we develop the full software stack: embedded firmware (RTOS, Linux-based, FreeRTOS), device management platform (OTA updates, fleet monitoring), cloud backend for data aggregation and product analytics, and customer-facing mobile or web applications.\n\nConnected product development requires firmware, cloud, and application expertise simultaneously. We bring all three rather than requiring you to coordinate separate vendors for each layer."
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ProfessionalService",
                            name: "IoT & Edge AI Engineering for Industrial Operations India",
                            url: "https://www.itmtb.com/services/iot-and-digital-eng",
                            image: "https://www.itmtb.com/services/capability/iot.webp",
                            description: "ITMTB builds IoT and edge AI systems for industrial operations — connected factory intelligence, predictive maintenance, real-time sensor data platforms, and Industry 4.0 deployments.",
                            provider: {
                                "@type": "Organization",
                                name: "ITMTB Technologies",
                                url: "https://www.itmtb.com",
                                logo: "https://www.itmtb.com/logo.webp"
                            },
                            areaServed: [
                                {
                                    "@type": "Place",
                                    name: "India"
                                }
                            ],
                            serviceType: [
                                "IoT Consulting India Manufacturing",
                                "Edge AI Industrial India",
                                "Industry 4.0 Implementation",
                                "IoT Sensor Data Platform",
                                "Predictive Maintenance AI",
                                "Connected Factory India",
                                "AWS IoT Core Consulting",
                                "Azure IoT Hub Consulting", 
                            ],
                            sameAs: [
                                "https://www.linkedin.com/company/itmtb-technologies/",
                                "https://x.com/ITMTBTech",
                                "https://www.instagram.com/itmtbtech/", 
                            ]
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                heading: "IoT and Edge AI Engineering",
                paragraph: "Industrial operations generate data at the machine level that most businesses can't yet act on — because it's locked in PLCs, SCADA systems, and legacy equipment that wasn't designed to share it.\n\nWe connect that data to modern analytics and AI systems: building IoT platforms that ingest high-frequency sensor streams, edge AI systems that run inference where the data is produced, and predictive maintenance models that flag equipment failure before it causes unplanned downtime.\n\nFor a global logistics company, we deployed a supply chain technology platform integrating Dynamics 365 across operations — unifying inventory visibility across multiple sites and enabling data-driven operational decisions that weren't possible with siloed systems.",
                bgPath: "/services/capability/iot.webp",
                primaryCta: {
                    label: "Talk to us →",
                    href: "/contact-us"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                referTag: "IoT and Digital Engineering",
                maxItems: 3,
                heading: "Selected work in IoT and digital engineering"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-8 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "max-w-4xl text-sm text-gray-500 leading-relaxed",
                    children: [
                        "IoT and digital engineering is one of the specialised practices within our broader",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/services/custom-software-development",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "custom software development"
                            })
                        }),
                        " ",
                        "capability, alongside platform engineering, application development, and AI-enabled systems."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                items: faqItems
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactUsHome, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (iotAndDigitalEng);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(513); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);